import * as SavedPropertiesActions from '@store/saved-properties/saved-properties.actions';

import { PropertyInformation, } from '@store/search-board/search-board.model';
import { PropertyUtil } from '@shared/utils/property-util';
import { SavedPropertiesState } from '@store/saved-properties/saved-properties.model';


export const savedPropertiesInitialState: SavedPropertiesState = {
  properties: [],
  checkedProperties: []
};

export function SavedPropertiesReducer(
  state: SavedPropertiesState = savedPropertiesInitialState,
  action: SavedPropertiesActions.All): SavedPropertiesState {
  switch (action.type) {

    case SavedPropertiesActions.UPDATE_SAVED_PROPERTIES_SUCCESS:
      return  {
        ...state,
        properties: action.payload,
        checkedProperties: []
      };

    case SavedPropertiesActions.CHECK_ALL_SAVED_PROPERTIES:
      return  {
        ...state,
        checkedProperties: state.properties.map((property: PropertyInformation) =>
          PropertyUtil.getCombinedIdFromPropertyInformation(property))
      };

    case SavedPropertiesActions.UNCHECK_ALL_SAVED_PROPERTIES:
      return  {
        ...state,
        checkedProperties: []
      };

    case SavedPropertiesActions.CHECK_SAVED_PROPERTY:
      return  {
        ...state,
        checkedProperties: [
          ...state.checkedProperties,
          action.payload
        ]
      };

    case SavedPropertiesActions.UNCHECK_SAVED_PROPERTY:
      const uncheckedPropertyId = action.payload;
      return  {
        ...state,
        checkedProperties: state.checkedProperties.filter((propertyId: string) => propertyId !== uncheckedPropertyId),
      };

    case SavedPropertiesActions.GET_SAVED_PROPERTIES_SUCCESS:
      return  {
        ...state,
        properties: action.payload,
      };

    default: {
      return state;
    }
  }
}
